import React, { useState, useEffect, useRef } from "react";

export default function EditableField({
	value,
	onSave,
	type = "text",
	className,
}) {
	const [editing, setEditing] = useState(false);
	const [currentValue, setCurrentValue] = useState(value);
	const inputRef = useRef(null);

	useEffect(() => {
		setCurrentValue(value);
	}, [value]);

	useEffect(() => {
		if (editing && inputRef.current) {
			inputRef.current.focus();
			if (type === "text") {
				inputRef.current.select();
			}
		}
	}, [editing, type]);

	function save() {
		if (currentValue !== value) {
			onSave(currentValue);
		}
		setEditing(false);
	}

	function handleKeyDown(e) {
		if (e.key === "Enter" && type !== "textarea") {
			e.preventDefault();
			save();
		} else if (e.key === "Escape") {
			setCurrentValue(value);
			setEditing(false);
		}
	}

	if (editing) {
		if (type === "textarea") {
			return (
				<textarea
					ref={inputRef}
					className={className}
					value={currentValue}
					onChange={(e) => setCurrentValue(e.target.value)}
					onBlur={save}
					onKeyDown={handleKeyDown}
					rows={3}
				/>
			);
		}
		return (
			<input
				ref={inputRef}
				className={className}
				type={type}
				value={currentValue}
				onChange={(e) => setCurrentValue(e.target.value)}
				onBlur={save}
				onKeyDown={handleKeyDown}
			/>
		);
	}

	return (
		<span
			className={className}
			onClick={() => setEditing(true)}
			style={{ cursor: "pointer" }}
		>
			{value ||
				(type === "textarea" ? "Click to add notes" : "Click to edit")}
		</span>
	);
}
